export default {
  name: "components-empty"
};